import { render, staticRenderFns } from "./configDialog.vue?vue&type=template&id=47e1c1f1&scoped=true"
import script from "./configDialog.vue?vue&type=script&lang=js"
export * from "./configDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e1c1f1",
  null
  
)

export default component.exports